import { billing } from '@repletoryreach/sdk-api';
import type { Translate } from '../i18n/I18nProvider';

/**
 * A flow refused because the plan has no room for another (HTTP 409 `PLAN_LIMIT_REACHED`): the plan's sentence in
 * the console's language, saying that entry points do not count. Since 30 October 2026 a save can be refused too, for
 * example when a greeting flow becomes a keyword flow on a full plan. Null for any other error.
 */
export function flowLimitMessage(e: unknown, t: Translate): string | null {
  if (!billing.isPlanLimitReached(e)) return null;
  const err = e.body.error;
  // Every refusal names the allowance; without one the service's own sentence is the best there is.
  if (err.allowance == null) return err.message;
  return t('flows.limit.reached', { plan: err.plan_name ?? '', count: err.allowance });
}

/** What to say when a flow could not be created or saved: the plan's sentence, or the error as it came. */
export function flowErrorMessage(e: unknown, t: Translate): string {
  return flowLimitMessage(e, t) ?? (e instanceof Error ? e.message : t('common.unknownError'));
}
